import styled, { css } from "styled-components";
import { IThemeProps, themeTypes } from "../../../../interfaces";
import { primary, inactiveItens, borderColors } from "../../../../theme";

export const ContainerContent = styled.div<IThemeProps>`
    flex: 1;
    overflow: auto;
    ${props => css`
        background: ${primary[props.theme as themeTypes]};
    `}
`;

export const InfoItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    flex: 1;
    min-width: 200px;
`;

export const InfoLabel = styled.span<IThemeProps>`
    font-size: 14px;
    font-weight: 600;
    ${props => css`
        color: ${inactiveItens[props.theme as themeTypes]};
    `}
`;

export const InfoValue = styled.span<IThemeProps>`
    font-size: 14px;
    padding: 8px 12px;
    border-radius: 4px;
    ${props => css`
        color: ${inactiveItens[props.theme as themeTypes]};
        background: ${primary[props.theme as themeTypes]};
        border: 1px solid ${borderColors[props.theme as themeTypes]};
    `}
`;

export const ContractText = styled.div<IThemeProps>`
    padding: 20px;
    border-radius: 8px;
    line-height: 1.6;
    word-wrap: break-word;
    max-height: calc(100vh - 200px);
    overflow-y: auto;
    font-size: 14px;
    ${props => css`
        color: ${inactiveItens[props.theme as themeTypes]};
        background: ${primary[props.theme as themeTypes]};
        border: 1px solid ${borderColors[props.theme as themeTypes]};
    `}

    /* Estilos para elementos HTML dentro do contrato */
    h1, h2, h3, h4, h5, h6 {
        margin: 16px 0 8px 0;
        font-weight: 600;
    }

    p {
        margin: 8px 0;
    }

    ul, ol {
        margin: 8px 0;
        padding-left: 20px;
    }

    li {
        margin: 4px 0;
    }

    table {
        border-collapse: collapse;
        width: 100%;
        margin: 16px 0;
    }

    th, td {
        border: 1px solid ${props => borderColors[props.theme as themeTypes]};
        padding: 8px 12px;
        text-align: left;
    }

    th {
        background-color: ${props => primary[props.theme as themeTypes]};
        font-weight: 600;
    }

    strong, b {
        font-weight: 600;
    }

    em, i {
        font-style: italic;
    }

    u {
        text-decoration: underline;
    }

    blockquote {
        border-left: 4px solid ${props => borderColors[props.theme as themeTypes]};
        margin: 16px 0;
        padding-left: 16px;
        font-style: italic;
    }
`; 